module.exports = __webpack_public_path__ + "img/xiaoguo.2aedc125.webp";